<ul class="MyMoeinList">

  <li *ngFor="let item of DataList_History">
      <a>
        <i class="fa fa-user"></i>
        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <b>{{item.fullname}}</b>
      </a>
      <div class="subMoeinDiv">
          <img src="{{BaseUrl}}{{item.imageUser}}" />
          <div class="subMoeinDivDetail">
              <p> نام و نام خانوادگی : {{item.fullname}}</p>
              <h6>{{item.btnDsc}}</h6>
          </div>
          <div style="clear:both"></div>
          <p class="subMoeinDsc"> توضیحات : {{item.dsc}} </p>
          <p class="subMoeinFooter"> زمان ارسال : {{item.submitDate}}</p>

      </div>
      <app-FlowchartHistory [DataList_History]="item.detail"></app-FlowchartHistory>
  </li>
</ul>
